import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { AlertDialogService } from '../../../../services/alert-dialog.service';
import countries from '../../../../../assets/json/countries.json';
import { Country } from '../../../../models/country.models';
import {CountryISO, SearchCountryField} from "@justin-s/ngx-intl-tel-input";
import {civilityOptions} from "../../../../shared/utils/data/etablissments-data";
@Component({
  selector: 'app-final-form-step',
  templateUrl: './final-form-step.component.html',
  styleUrl: './final-form-step.component.scss'
})
export class FinalFormStepComponent implements OnInit {
  @Input() finalStepFormGroup : FormGroup
  @Input() contactForm : FormGroup
  @Input() contacts : FormArray
  @Input() loading = false
  @Output() onSubmit = new EventEmitter<any>();
  @Input() removeNewContact: Function
  @Input() phoneSelected: any
  countriesList : Country[] = countries
  separateDialCode = false;
  options = [{value : "MONSIEUR", label : "Mr",}
  ,{value : "MONSIEUR", label : "Mrs"}
  ,{value : "Ms", label : "Ms"}
  ,{value : "Miss", label : "Miss"}
  ,{value : "Dr", label : "Dr"}
  ,{value : "Pr", label : "Pr"}
  ]
  phoneMaxLength: number = 10;
  phoneNumber: string | undefined;
  constructor(private alertDialogService: AlertDialogService, private fb: FormBuilder) {
    // this.contacts.push(this.contactForm)
  }
  ngOnInit(): void {

  }



  // get contacts(): FormArray {
  //   return this.finalStepFormGroup.get('persons') as FormArray
  // }

  deleteNewContact(index : number) : void{
    this.alertDialogService
    ?.openAlertModal(
      'success',
      'Confirmation',
      'Êtes-vous sûr(e) de vouloir supprimer ce contact ? Toutes les informations associées seront perdues. Confirmez la suppression pour continuer.',
      'Supprimer',
      'Annuler'
    )
    ?.subscribe((res) => {
      if (res) {
        this.contacts.removeAt(index)
      // this.removeNewContact(index)
      }
    });

  }

  getImage(images: string[], index: number) {
    const photot1 = this.contacts.controls[index].get('photo1')
    const photot2 = this.contacts.controls[index].get('photo2')
    photot1?.patchValue('')
    photot2?.patchValue('')

    if (images[0]) {
      photot1?.patchValue(images[0])
    }
    if (images[1]) {
      photot2?.patchValue(images[1])
    }
  }


  addNewContact() {
    this.contacts.push(this.fb.group({
      civility: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      fullnamepersonnecontact: [''],
      fonction: ['', Validators.required],
      mail: ['', [Validators.required, Validators.email]],
      numTel: ['', Validators.required],
      title: [''],
      photo1: [''],
      photo2: [''],
    }))

  }
  onInputChange(event: any) {
    const inputNumber = event?.number;

    if (!inputNumber) return;

    
     if (inputNumber.startsWith('0')) {
       this.phoneMaxLength = 10;
     } else {
         this.phoneMaxLength = 9;
     
    }
    if (inputNumber.length > this.phoneMaxLength) {
      this.phoneNumber = inputNumber.slice(0, this.phoneMaxLength);
      this.contacts.get('numTel')?.setValue(this.phoneNumber);
    } else {
      this.phoneNumber = inputNumber;
      this.contacts.get('numTel')?.setValue(this.phoneNumber);
    }
  }
  protected readonly CountryISO = CountryISO;
  protected readonly SearchCountryField = SearchCountryField;
  protected readonly civilityOptions = civilityOptions;
}
